/* eslint-disable max-len */
import { createAction } from 'redux-actions';
import * as constants from 'constants/index';

export const showSnackbar = createAction(constants.SNACKBAR_SHOW);
export const hideSnackbar = createAction(constants.SNACKBAR_HIDE);

export const resetUserState = createAction(constants.RESET_USER_STATE);
export const fetchUserSelfRequest = createAction(constants.FETCH_USER_SELF_REQUEST);
export const fetchUserSelfIdle = createAction(constants.FETCH_USER_SELF_IDLE);
export const fetchUserSelfSuccess = createAction(constants.FETCH_USER_SELF_SUCCSSS);
export const fetchUserSelfFailure = createAction(constants.FETCH_USER_SELF_FAILURE);

export const listCottageImagesRequest = createAction(constants.LIST_COTTAGE_IMAGES_REQUEST);
export const listCottageImagesIdle = createAction(constants.LIST_COTTAGE_IMAGES_IDLE);
export const listCottageImagesSuccess = createAction(constants.LIST_COTTAGE_IMAGES_SUCCESS);
export const listCottageImagesFailure = createAction(constants.LIST_COTTAGE_IMAGES_FAILURE);

export const reorderCottageImages = createAction(constants.REORDER_COTTAGE_IMAGES);
export const reorderCottageImagesRequest = createAction(constants.REORDER_COTTAGE_IMAGES_REQUEST);
export const reorderCottageImagesIdle = createAction(constants.REORDER_COTTAGE_IMAGES_IDLE);
export const reorderCottageImagesSuccess = createAction(constants.REORDER_COTTAGE_IMAGES_SUCCESS);
export const reorderCottageImagesFailure = createAction(constants.REORDER_COTTAGE_IMAGES_FAILURE);

export const removeCottageImagesRequest = createAction(constants.REMOVE_COTTAGE_IMAGES_REQUEST);
export const removeCottageImagesIdle = createAction(constants.REMOVE_COTTAGE_IMAGES_IDLE);
export const removeCottageImagesSuccess = createAction(constants.REMOVE_COTTAGE_IMAGES_SUCCESS);
export const removeCottageImagesFailure = createAction(constants.REMOVE_COTTAGE_IMAGES_FAILURE);

export const updateCottageImageRequest = createAction(constants.UPDATE_COTTAGE_IMAGE_REQUEST);
export const updateCottageImageIdle = createAction(constants.UPDATE_COTTAGE_IMAGE_IDLE);
export const updateCottageImageSuccess = createAction(constants.UPDATE_COTTAGE_IMAGE_SUCCESS);
export const updateCottageImageFailure = createAction(constants.UPDATE_COTTAGE_IMAGE_FAILURE);

export const fetchRoomRequest = createAction(constants.FETCH_ROOM_REQUEST);
export const fetchRoomIdle = createAction(constants.FETCH_ROOM_IDLE);
export const fetchRoomSuccess = createAction(constants.FETCH_ROOM_SUCCESS);
export const fetchRoomFailure = createAction(constants.FETCH_ROOM_FAILURE);

export const fetchCottageImageRequest = createAction(constants.FETCH_COTTAGE_IMAGE_REQUEST);
export const fetchCottageImageIdle = createAction(constants.FETCH_COTTAGE_IMAGE_IDLE);
export const fetchCottageImageSuccess = createAction(constants.FETCH_COTTAGE_IMAGE_SUCCESS);
export const fetchCottageImageFailure = createAction(constants.FETCH_COTTAGE_IMAGE_FAILURE);
export const fetchCottageImageDestroy = createAction(constants.FETCH_COTTAGE_IMAGE_DESTROY);

export const openImageDeleteConfirmationModal = createAction(
  constants.OPEN_IMAGE_DELETE_CONFIRMATION_MODAL,
);
export const closeImageDeleteConfirmationModal = createAction(
  constants.CLOSE_IMAGE_DELETE_CONFIRMATION_MODAL,
);

export const openImageUploadLeavePageModal = createAction(
  constants.OPEN_IMAGE_UPLOAD_LEAVE_PAGE_MODAL,
);
export const closeImageUploadLeavePageModal = createAction(
  constants.CLOSE_IMAGE_UPLOAD_LEAVE_PAGE_MODAL,
);

export const cottageImageUploadRequest = createAction(constants.COTTAGE_IMAGE_UPLOAD_REQUEST);
export const cottageImageUploadInsert = createAction(constants.COTTAGE_IMAGE_UPLOAD_INSERT);
export const cottageImageUploadUpdate = createAction(constants.COTTAGE_IMAGE_UPLOAD_UPDATE);
export const cottageImageUploadIdle = createAction(constants.COTTAGE_IMAGE_UPLOAD_IDLE);
export const cottageImageUploadSuccess = createAction(constants.COTTAGE_IMAGE_UPLOAD_SUCCESS);
export const cottageImageUploadFailure = createAction(constants.COTTAGE_IMAGE_UPLOAD_FAILURE);

export const generateImagePreviewRequest = createAction(constants.GENERATE_IMAGE_PREVIEW_REQUEST);
export const generateImagePreviewIdle = createAction(constants.GENERATE_IMAGE_PREVIEW_IDLE);
export const generateImagePreviewSuccess = createAction(constants.GENERATE_IMAGE_PREVIEW_SUCCESS);
export const generateImagePreviewFailure = createAction(constants.GENERATE_IMAGE_PREVIEW_FAILURE);

export const fetchCalendarRequest = createAction(constants.FETCH_CALENDAR_REQUEST);
export const fetchCalendarIdle = createAction(constants.FETCH_CALENDAR_IDLE);
export const fetchCalendarSuccess = createAction(constants.FETCH_CALENDAR_SUCCESS);
export const fetchCalendarFailure = createAction(constants.FETCH_CALENDAR_FAILURE);

export const updateCalendarRequest = createAction(constants.UPDATE_CALENDAR_REQUEST);
export const updateCalendarIdle = createAction(constants.UPDATE_CALENDAR_IDLE);
export const updateCalendarSuccess = createAction(constants.UPDATE_CALENDAR_SUCCESS);
export const updateCalendarFailure = createAction(constants.UPDATE_CALENDAR_FAILURE);
export const setCalendarRows = createAction(constants.SET_CALENDAR_ROWS);

export const updateCottageSettingsRequest = createAction(constants.UPDATE_COTTAGE_SETTINGS_REQUEST);
export const updateCottageSettingsIdle = createAction(constants.UPDATE_COTTAGE_SETTINGS_IDLE);
export const updateCottageSettingsSuccess = createAction(constants.UPDATE_COTTAGE_SETTINGS_SUCCESS);
export const updateCottageSettingsFailure = createAction(constants.UPDATE_COTTAGE_SETTINGS_FAILURE);

export const postLoginRequest = createAction(constants.POST_LOGIN_REQUEST);
export const postLoginSuccess = createAction(constants.POST_LOGIN_SUCCESS);
export const postLoginFailure = createAction(constants.POST_LOGIN_FAILURE);
export const postLoginIdle = createAction(constants.POST_LOGIN_IDLE);

export const postLogoutRequest = createAction(constants.POST_LOGOUT_REQUEST);
export const postLogoutSuccess = createAction(constants.POST_LOGOUT_SUCCESS);
export const postLogoutFailure = createAction(constants.POST_LOGOUT_FAILURE);
export const postLogoutIdle = createAction(constants.POST_LOGOUT_IDLE);

export const loginCheckUsername = createAction(constants.LOGIN_CHECK_USERNAME_REQUEST);
export const loginSetUserType = createAction(constants.LOGIN_SET_USERTYPE);

export const loginResetForm = createAction(constants.LOGIN_RESET_FORM);

export const postCreateUserRequest = createAction(constants.LOGIN_CREATE_USER_REQUEST);

export const postCreateUserSuccess = createAction(constants.POST_CREATE_USER_SUCCESS);

export const updateUserRequest = createAction(constants.UPDATE_USER_REQUEST);
export const updateUserSuccess = createAction(constants.UPDATE_USER_SUCCESS);
export const updateUserFailure = createAction(constants.UPDATE_USER_FAILURE);
export const updateUserIdle = createAction(constants.UPDATE_USER_IDLE);

export const deleteUserRequest = createAction(constants.DELETE_USER_REQUEST);
export const deleteUserFailure = createAction(constants.DELETE_USER_FAILURE);
export const deleteUserIdle = createAction(constants.DELETE_USER_IDLE);

export const resetUserForm = createAction(constants.RESET_USER_FORM);

export const fetchBookingsInfoRequest = createAction(constants.FETCH_BOOKINGS_INFO_REQUEST);
export const fetchBookingsInfoSuccess = createAction(constants.FETCH_BOOKINGS_INFO_SUCCESS);
export const fetchBookingsInfoFailure = createAction(constants.FETCH_BOOKINGS_INFO_FAILURE);

export const fetchBookingsRequest = createAction(constants.FETCH_BOOKINGS_REQUEST);
export const fetchBookingsSuccess = createAction(constants.FETCH_BOOKINGS_SUCCESS);
export const fetchBookingsFailure = createAction(constants.FETCH_BOOKINGS_FAILURE);

export const fetchBookingRequest = createAction(constants.FETCH_BOOKING_REQUEST);
export const fetchBookingSuccess = createAction(constants.FETCH_BOOKING_SUCCESS);
export const fetchBookingFailure = createAction(constants.FETCH_BOOKING_FAILURE);

export const putBookingRequest = createAction(constants.PUT_BOOKING_REQUEST);
export const putBookingSuccess = createAction(constants.PUT_BOOKING_SUCCESS);
export const putBookingFailure = createAction(constants.PUT_BOOKING_FAILURE);
export const putBookingIdle = createAction(constants.PUT_BOOKING_IDLE);

export const fetchCancellationPolicyRequest = createAction(
  constants.FETCH_CANCELLATION_POLICY_REQUEST,
);
export const fetchCancellationPolicySuccess = createAction(
  constants.FETCH_CANCELLATION_POLICY_SUCCESS,
);
export const fetchCancellationPolicyFailure = createAction(
  constants.FETCH_CANCELLATION_POLICY_FAILURE,
);

export const postBookingRequest = createAction(constants.POST_BOOKING_REQUEST);
export const postBookingSuccess = createAction(constants.POST_BOOKING_SUCCESS);
export const postBookingFailure = createAction(constants.POST_BOOKING_FAILURE);
export const postBookingIdle = createAction(constants.POST_BOOKING_IDLE);

export const bookingActionRequest = createAction(constants.BOOKING_ACTION_REQUEST);
export const bookingActionSuccess = createAction(constants.BOOKING_ACTION_SUCCESS);
export const bookingActionFailure = createAction(constants.BOOKING_ACTION_FAILURE);

export const fetchUploadedKYCRequest = createAction(constants.FETCH_UPLOADED_KYC_REQUEST);
export const fetchUploadedKYCSuccess = createAction(constants.FETCH_UPLOADED_KYC_SUCCESS);
export const fetchUploadedKYCFailure = createAction(constants.FETCH_UPLOADED_KYC_FAILURE);

export const uploadIDProofRequest = createAction(constants.UPLOAD_IDPROOF_REQUEST);
export const uploadIDProofSuccess = createAction(constants.UPLOAD_IDPROOF_SUCCESS);
export const uploadIDProofFailure = createAction(constants.UPLOAD_IDPROOF_FAILURE);
export const uploadIDProofIdle = createAction(constants.UPLOAD_IDPROOF_IDLE);

export const postAuthTokenRequest = createAction(constants.POST_AUTH_TOKEN_REQUEST);
export const postAuthTokenResponse = createAction(constants.POST_AUTH_TOKEN_RESPONSE);

export const authTokenSent = createAction(constants.AUTH_TOKEN_SENT);
export const authTokenFailure = createAction(constants.AUTH_TOKEN_FAILURE);

export const fetchSelfEvents = createAction(constants.FETCH_SELF_EVENTS_REQUEST);
export const fetchSelfEventsSuccess = createAction(constants.FETCH_SELF_EVENTS_SUCCESS);
export const fetchSelfEventsFailure = createAction(constants.FETCH_SELF_EVENTS_FAILURE);
export const updateSelfEvents = createAction(constants.UPDATE_SELF_EVENTS_REQUEST);
export const updateSelfEventsFailure = createAction(constants.UPDATE_SELF_EVENTS_FAILURE);

export const fetchTodos = createAction(constants.FETCH_TODOS_REQUEST);
export const fetchTodosSuccess = createAction(constants.FETCH_TODOS_SUCCESS);
export const fetchTodosFailure = createAction(constants.FETCH_TODOS_FAILURE);
export const patchTodosReadNews = createAction(constants.PATCH_TODOS_READ_NEWS);

export const scaPreEnroll = createAction(constants.SCA_PRE_ENROLL);
export const scaPreEnrollReset = createAction(constants.SCA_PRE_ENROLL_RESET);
export const scaRecipientEnrollReset = createAction(constants.SCA_RECIPIENT_ENROLL_RESET);
export const scaStartEnrollment = createAction(constants.SCA_START_ENROLLMENT);
export const scaTriggerOn = createAction(constants.SCA_TRIGGER_ON);
export const scaTriggerOff = createAction(constants.SCA_TRIGGER_OFF);
export const scaVerifyRedirectParams = createAction(constants.SCA_VERIFY_REDIRECT_PARAMS);
export const scaVerifyRedirectSuccess = createAction(constants.SCA_VERIFY_REDIRECT_SUCCESS);
export const scaVerifyRedirectFailure = createAction(constants.SCA_VERIFY_REDIRECT_FAILURE);
export const scaVerificationReset = createAction(constants.SCA_VERIFICATION_RESET);

export const scaRecipientEnroll = createAction(constants.SCA_RECIPIENT_ENROLL);
export const scaStartRecipientEnrollment = createAction(
  constants.SCA_START_RECIPIENT_ENROLLMENT,
  ({ actionUrl, rid, returnUrl }) => ({ actionUrl, rid, returnUrl }),
);

export const scaSyncRecipient = createAction(constants.SCA_SYNC_RECIPIENT, ({ rid }) => ({ rid }));

export const scaRecipientReady = createAction(constants.SCA_RECIPIENT_READY);
export const scaSyncRecipientReset = createAction(constants.SCA_SYNC_RECIPIENT_RESET);

export const scaVerifyRecipientRedirectParams = createAction(
  constants.SCA_VERIFY_RECIPIENT_REDIRECT_PARAMS,
  ({ controlStatus, rid }) => ({ controlStatus, rid }),
);

export const scaResumeRequest = () => ({ type: constants.SCA_RESUME_REQUEST });
export const scaResumeSuccess = () => ({ type: constants.SCA_RESUME_SUCCESS });
export const scaResumeFailure = (error) => ({ type: constants.SCA_RESUME_FAILURE, error });
export const scaResumeTickCooldown = () => ({ type: constants.SCA_RESUME_TICK_COOLDOWN });
export const scaPollLocalRequest = () => ({ type: constants.SCA_POLL_LOCAL_REQUEST });

export const fetchSessionStatusRequest = createAction(constants.FETCH_SESSION_STATUS_REQUEST);
export const fetchSessionStatusSuccess = createAction(constants.FETCH_SESSION_STATUS_SUCCESS);
export const fetchSessionStatusFailure = createAction(constants.FETCH_SESSION_STATUS_FAILURE);
